module.exports = __webpack_public_path__ + "img/undraw_Upvote_re_qn2k.4062c03d.png";